import * as React from "react";
import * as ReactDOM from "react-dom";
import { SpsNotification } from "../react/";

NgRun.$inject = [
    '$translate',
    '$CurrentUser'
];

export function NgRun($translate, $CurrentUser) {

    $CurrentUser.onPrefsChange((prefs) => {
        const lang = (Array.isArray(prefs.language))
            ? prefs.language[0]
            : prefs.language;
        $translate.use(lang || 'en-US');
    }, true);

}
